export default function about() {
  return (
    <section id='about' className='content'>
      <h3>About</h3>
      <p>
        I develop systems that automate and simplify business and life for small
        businesses and their clients. I am passionate about implementing
        solutions and solving problems. I am proficient in Javascript, React, Shopify and
        Node.
      </p>
    </section>
  );
}
